var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"py-2 modeButton",attrs:{"src":_vm.image,"contain":"","width":"15vw"},on:{"click":function($event){return _vm.$store.dispatch('updateSystemMode')}}})}
var staticRenderFns = []

export { render, staticRenderFns }